module.exports = __webpack_public_path__ + "img/logo.444b0b9d.png";